module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-152x152-17f897eacb7a05efa6475eed4c307aaf.png";